import { AssetInfo } from './../../../models/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { ApiService } from 'src/app/providers/api.service';
import { Component, Inject, OnInit, OnDestroy, NgZone } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { BuisnessPromotion } from 'src/app/models/common';

import { LoaderServiceService } from 'src/app/providers/loader-service.service';

@Component({
  selector: 'sm-add-employee-salary-setting',
  templateUrl: './add-employee-salary-setting.component.html',
  styleUrls: ['./add-employee-salary-setting.component.scss']
})
export class AddEmployeeSalarySettingComponent implements OnInit, OnDestroy {
  public newSalarySettingData: any = {
    payType: 1,
    payRate: null,
    paidOn: 1,
    netPayment: null,
    otherPerks: null,
    perksType: null,
    deduction: null,
    deductionType: null
  }
  public editCreditData: any = {
    amount: null,
    status: 1
  }
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  public loader: boolean = false;
  private _assetInfo: AssetInfo[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private _ngZone: NgZone,
    private loaderservice: LoaderServiceService
  ) {}

  removeAsset(index: any) {
    console.log(index);
    this.assetList.splice(index, 1);
  }

  ngOnInit(): void {
    let data: any = new BuisnessPromotion();

    Object.assign(data, this.parentData.data);
    console.log(data);

      // this.newSalarySettingData = data;
      this.editMode = data.editMode;

      if(data.editMode){
        this.newSalarySettingData = {
          ...this.newSalarySettingData,
          payType: data.settingsData.payType?.toString(),
          payRate: data.settingsData.payRate?.toString(),
          paidOn: data.settingsData.paidOn?.toString(),
          netPayment: data.settingsData.netPayment?.toString(),
          otherPerks: data.settingsData.otherPerks?.toString(),
          perksType: data.settingsData.perksType?.toString(),
          deduction: data.settingsData.deduction?.toString(),
          deductionType: data.settingsData.deductionType?.toString()
        };
        console.log(this.newSalarySettingData);
        this.changeRates()
      }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result.url);
        this._ngZone.run(() => {
          this.assetList.push({
            assetName: this.fileName,
            url: res.result?.url,
            thumbnail: res.result?.thumbnail,
          });
          console.log(this.assetList);
          this.loader = false;
        });
        // this.newSalarySettingData.imgUrl = res.result?.url;
      }
      if (res.responseType === SM_CONSTANTS.RESULT_API_UPDATE_SALARY_INFO) {
        if(res.result){
          this.parentData.ref.closeAll();
        }
      
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    if(!this.editMode){
      let data = {
        salaryInfo : {
          payType: this.newSalarySettingData.payType,
          payRate: this.newSalarySettingData.payRate,
          paidOn: this.newSalarySettingData.paidOn,
          netPayment: this.newSalarySettingData.netPayment,
          otherPerks: this.newSalarySettingData.otherPerks,
          perksType: this.newSalarySettingData.perksType,
          deduction: this.newSalarySettingData.deduction,
          deductionType: this.newSalarySettingData.deductionType,
        }
       }
    
       console.log(data); 
       this.loaderservice.showLoader = true
       this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'1')
    }

    else if (this.editMode){
      let data = {
        salaryInfo : {
          hash_id: this.parentData.data.settingsData.hash_id,
          payType: this.newSalarySettingData.payType,
          payRate: this.newSalarySettingData.payRate,
          paidOn: this.newSalarySettingData.paidOn,
          netPayment: this.newSalarySettingData.netPayment,
          otherPerks: this.newSalarySettingData.otherPerks,
          perksType: this.newSalarySettingData.perksType,
          deduction: this.newSalarySettingData.deduction,
          deductionType: this.newSalarySettingData.deductionType,
        }
       }
    
       console.log(data); 
       this.loaderservice.showLoader = true
       this._apiService.updateSalaryInfo(this.parentData.data.employeeHash,data,'1')
       
    }
 

   
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);
  
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  formatDateForEdit(originalDate: string) {
    const date = new Date(originalDate);
    
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getUTCDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

    changeRates(){
  setTimeout(() => {
    
      this.newSalarySettingData.np = +this.newSalarySettingData.netPayment + +this.newSalarySettingData.otherPerks - +this.newSalarySettingData.deduction
  },0);
  }
}
